import { Api } from '../api';
import {ICreateUsuarioRole,ICreateUsuario, IResponseUsuarioOrg,IListagemUsuario, IListagemUsuarioRole, IMeSession, IResponseUsuario, IResponseUsuarioRole, ICreateUsuarioOrg} from 'shared/types';
import { t } from 'i18next';

const getMe = async (): Promise<IMeSession | Error> => {
  try {
    const { data } = await Api.get('/Usuarios/me');
    if (data) {
      return data;
    }

    return new Error('Erro ao listar permissões.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar permissoes.');
  }
};

const getAll = async (filter = ''): Promise<IResponseUsuario | Error> => {
  try {
    const { data, status } = await Api.get(`/Usuarios${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: number): Promise<IListagemUsuario | Error> => {
  try {
    const { data } = await Api.get(`/Usuarios/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const getAllRoles = async (idUsuario: number, filter = ''): Promise<IResponseUsuarioRole | Error> => {
  try {
    const { data, status } = await Api.get(`/Usuarios/${idUsuario}/Roles${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllOrgs = async (idUsuario: number, filter = ''): Promise<IResponseUsuarioOrg | Error> => {
  try {
    const { data, status } = await Api.get(`/UsuOrg/${idUsuario}${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getUsuarioRole = async (idUsuario: number, id: number): Promise<IListagemUsuarioRole | Error> => {
  try {
    const { data, status } = await Api.get(`/Usuarios/${idUsuario}/Roles/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};
const getUsuarioOrg = async (idUsuario: number, id: number): Promise<IListagemUsuarioRole | Error> => {
  try {
    const { data, status } = await Api.get(`/Usuarios/${idUsuario}/Org/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const createUsuarioRole = async (idUsuario: number, dados: ICreateUsuarioRole): Promise<void | Error> => {
  try {
    const { data, status } = await Api.post(`/Usuarios/${idUsuario}/Roles`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const createUsuarioOrg = async ( idUsuario: number,dados: ICreateUsuarioOrg): Promise<void | Error> => {
  try {
    const { data, status } = await Api.post(`/UsuOrg/UsuarioOrg/${idUsuario}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};



const deleteUsuarioRole = async (idUsuario: number, id: number): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Usuarios/${idUsuario}/Roles/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};
const deleteUsuarioOrg = async (idUsuario: number, id: number): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/UsuOrg/${idUsuario}/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const create = async (dados: ICreateUsuario): Promise<string | Error> => {
  try {
    if(dados.UsuarioNome != undefined && dados.UsuarioNome.trim().split(' ').length < 2){
      return new Error(t('messages.usuario.create'));
    }

    const { data, status } = await Api.post('/Usuarios/Usuario', dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        if('errors' in data){
          const chaves = Object.keys(data.errors); // Acessar a primeira chave const primeiraPropriedade = chaves[0];
          return new Error(data.errors[chaves[0]][0]);
        }else{
          return new Error(`${data.retorno} `);    
        }
      }
      return data;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (id:number,dados: ICreateUsuario,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/Usuarios/Usuario/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      if('errors' in data){
        const chaves = Object.keys(data.errors); // Acessar a primeira chave const primeiraPropriedade = chaves[0];
        return new Error(data.errors[chaves[0]][0]);
      }else{
        return new Error(`${data.retorno} `);    
      }
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

export const UsuariosService = {
  getMe,
  getAll,
  create,
  updateById,
  getById,
  getAllRoles,
  getAllOrgs,
  createUsuarioRole,
  createUsuarioOrg,
  getUsuarioRole,
  getUsuarioOrg,
  deleteUsuarioRole,
  deleteUsuarioOrg
};
